import axios from 'axios';

export async function uploadTemporaryFile(blob, originalName, client = axios) {
    const formData = new FormData();
    formData.append('file', blob, originalName);
    const response = await client.post('/api/upload-temp-file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
}